import { makeStyles } from '@material-ui/core';

import { VARIANT } from '../../shared/consts';

import type { SaturationStateProp } from '../../shared/models';

export default makeStyles({
  btn: ({ variant }: SaturationStateProp) => ({
    padding: '0.5rem 0.75rem',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    boxShadow: 'none',
    borderRadius: '0.5rem',
    color: VARIANT[variant].color,
    backgroundColor: VARIANT[variant].bgColor,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: `${VARIANT[variant].bgColor}9B`,
    },
    '&:disabled': {
      color: VARIANT.deactivated.color,
      backgroundColor: VARIANT[variant].bgColor,
    },
  }),
});
